import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { isSeen, markSeen } from './lib/notificationDedupe';

const firebaseConfig = {
  apiKey: 'AIzaSyAuWgJCtgOoeC1kmKmxAvvl7sDCVAwdjcI',
  authDomain: 'zno-game.firebaseapp.com',
  projectId: 'zno-game',
  storageBucket: 'zno-game.firebasestorage.app',
  messagingSenderId: '475224114993',
  appId: '1:475224114993:web:59459e8899d4c3a72e9210',
  measurementId: 'G-HL2WZ8F922'
};

// Firebase app
const app = initializeApp(firebaseConfig);

let messaging = null;
let messagingSupportedPromise = null;

async function ensureMessaging() {
  if (typeof window === 'undefined') return null;
  if (!('serviceWorker' in navigator)) return null;

  try {
    if (!messagingSupportedPromise) {
      messagingSupportedPromise = isSupported();
    }
    const supported = await messagingSupportedPromise;
    if (!supported) return null;

    if (!messaging) messaging = getMessaging(app);
    return messaging;
  } catch (err) {
    console.warn('Firebase Messaging non disponible:', err?.message || err);
    return null;
  }
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.log('Service Workers non supportés');
    return null;
  }

  try {
  // Register the static service worker (served from /public in Vite)
  const registration = await navigator.serviceWorker.register(
    '/firebase-messaging-sw.js',
    { scope: '/' }
  );

  // Ensure SW is activated
  await navigator.serviceWorker.ready;

  console.log('Service Worker enregistré avec succès (statique)');
  return registration;
} catch (err) {
  console.error('Échec de l\'enregistrement du Service Worker:', err);
  return null;
}
}

/**
 * Get FCM token
 * IMPORTANT:
 * - must use "vapidKey" (not vapidPublicKey)
 * - must pass serviceWorkerRegistration when SW is custom
 */
export async function getFCMToken(serviceWorkerRegistration) {
  const msg = await ensureMessaging();
  if (!msg || typeof window === 'undefined') {
    console.log('Firebase Messaging non disponible');
    return null;
  }

  try {
    if (!('Notification' in window)) return null;
    if (!window.isSecureContext) {
      console.log('Contexte non sécurisé (HTTPS requis)');
      return null;
    }
    if (Notification.permission !== 'granted') {
      console.log('Permission de notification non accordée');
      return null;
    }
    if (!serviceWorkerRegistration) {
      console.log('serviceWorkerRegistration manquant');
      return null;
    }

    const token = await getToken(msg, {
      vapidKey: 'BLebRkm4Gubys8oiWmhXTXrLJPLv1cj3eA8746Jb2axwEZvVDQpVU328tloJK0C_xIEOemIjOi3gqCtAzH2erjc',
      serviceWorkerRegistration
    });

    if (token) {
      console.log('Token FCM récupéré');
      return token;
    }

    console.log('Token FCM est null');
    return null;
  } catch (err) {
    console.error('Erreur lors de la récupération du token FCM:', err);
    return null;
  }
}

/**
 * Foreground messages
 */
export async function setupForegroundMessageListener(callback) {
  const msg = await ensureMessaging();
  if (!msg) return () => {};

  try {
    const unsubscribe = onMessage(msg, (payload) => {
      console.log('Notification reçue au premier plan:', payload);

      // Déduplication via eventTag
      const eventTag = payload?.data?.tag;
      if (eventTag && isSeen(eventTag)) {
        console.log('Notification already seen (foreground):', eventTag);
        return;
      }

      // Marquer comme vu
      if (eventTag) {
        markSeen(eventTag);
      }

      // Show browser notification in foreground with click-to-open support
      if ('Notification' in window && Notification.permission === 'granted') {
        try {
          const title = payload?.notification?.title || payload?.data?.title || 'ZNO';
          const body = payload?.notification?.body || payload?.data?.body || 'Nouveau message';
          const notif = new Notification(title, {
            body,
            icon: 'https://jszqmvsvkasqsnxkhqor.supabase.co/storage/v1/object/public/playground-photos/zno-icon.png',
            tag: eventTag || 'zno-notification',
            data: payload?.data || {}
          });

          // Handle click on foreground notification — open the right bottom sheet
          notif.onclick = () => {
            window.focus();
            notif.close();
            const data = payload?.data || {};
            const url = data.url || data.link || data.click_action;

            // Extract playground_id from data or URL ?selected= param
            const playgroundId = data.playground_id || (() => {
              if (!url) return null;
              try {
                const params = new URLSearchParams(url.split('?')[1] || '');
                return params.get('selected');
              } catch (_) { return null; }
            })();

            if (playgroundId) {
              window.dispatchEvent(new CustomEvent('zno:openPlayground', {
                detail: { playground_id: playgroundId }
              }));
            } else if (url) {
              window.location.href = url;
            }
          };
        } catch (err) {
          console.error('Échec de l\'affichage de la notification au premier plan:', err);
        }
      }

      callback?.(payload);
    });

    return unsubscribe;
  } catch (err) {
    console.error('Échec de la configuration du listener au premier plan:', err);
    return () => {};
  }
}

export { app, messaging };